import { createUniqueId, splitProps } from "solid-js";
import { formControlProps, InputFormControl } from "./formControl";
import FormControlErrors, { errorId } from "./FormControlErrors";
import FormLabel from "./FormLabel";

const NumberFormControl: InputFormControl<
  number | undefined,
  "number" | "range"
> = (props) => {
  const [local, inputProps] = splitProps(props, formControlProps);
  const id = local.id ?? createUniqueId();
  const invalid = () => (local.errors || []).length > 0;
  return (
    <>
      <FormLabel for={id}>{local.label}</FormLabel>
      <input
        {...inputProps}
        id={id}
        classList={{
          ...local.classList,
          ["form-control"]: true,
          ["is-invalid"]: invalid(),
        }}
        aria-error-message={invalid() && errorId(id, 0)}
        aria-invalid={invalid()}
      />
      <FormControlErrors for={id} errors={local.errors} />
    </>
  );
};
export default NumberFormControl;
